import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaHome, FaExclamationTriangle } from 'react-icons/fa';
import AppStoreBadges from '../components/AppStoreBadges';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  background: linear-gradient(135deg, #1a1a2e 0%, #2d2d3e 100%);
`;

const ErrorIcon = styled.div`
  font-size: 4rem;
  color: var(--color-primary, #FF6B6B);
  margin-bottom: 1.5rem;
  animation: pulse 2s infinite;

  @keyframes pulse {
    0%, 100% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.1); opacity: 0.8; }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const Title = styled.h1`
  font-size: 7rem;
  font-weight: 800;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, var(--color-primary, #FF6B6B) 0%, #ff8e8e 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 5rem;
  }
`;

const Message = styled.p`
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.8);
  max-width: 500px;
  margin: 0 auto 2rem;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const HomeButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: var(--color-primary, #FF6B6B);
  color: white;
  padding: 0.875rem 2rem;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  margin-bottom: 3rem;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 25px rgba(255, 107, 107, 0.4);
  }
`;

const Divider = styled.div`
  width: 60px;
  height: 2px;
  background: rgba(255, 255, 255, 0.2);
  margin-bottom: 2rem;
`;

const DownloadText = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.95rem;
  margin-bottom: 1.5rem;
`;

const NotFoundPage: React.FC = () => {
  return (
    <Container>
      <ErrorIcon>
        <FaExclamationTriangle />
      </ErrorIcon>
      <Title>404</Title>
      <Message>
        Oops! The page you're looking for doesn't exist or has been moved.
      </Message>
      <HomeButton to="/">
        <FaHome /> Return to Home
      </HomeButton>

      <Divider />
      <DownloadText>Looking for the app? Download it here:</DownloadText>
      <AppStoreBadges variant="dark" size="md" />
    </Container>
  );
};

export default NotFoundPage;
